import "./upload.css.ts.vanilla.mjs";
var c = "p273__upload-c3be_cc5f5d2__1j1yz8o1", o = "p273__upload-c3be_cc5f5d2__1j1yz8o0", p = "p273__upload-c3be_cc5f5d2__1j1yz8o3", a = "p273__upload-c3be_cc5f5d2__1j1yz8o2";
export {
  c as darkTheme,
  o as lightTheme,
  p as uploadListStyle,
  a as uploadStyle
};
//# sourceMappingURL=upload.mjs.map
